export const ROW_TMP = {
  feeTypeCode: '',
  specialRules: '',
  startNumber: '',
  endNumber: '',
  deliveryFeeRatio: ''
};
